import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import {ToastrService} from 'ngx-toastr'; // your toast service
import {TranslateService} from '@ngx-translate/core'; // translation service
import {Subscription} from 'rxjs';
import {PatientFacadeService} from 'src/app/main/patients/patients-facade.service';
import {ActivityLogs, ActivityTypes, CalActivitySubTypes} from '../models';
import {User} from '@drl/core/auth/models/user.model';
import {ConfigKeys} from '@drl/core/enums';

@Component({
  selector: 'app-call-log-dialog',
  templateUrl: './call-log-dialog.component.html',
  styleUrls: ['./call-log-dialog.component.scss'],
})
export class CallLogDialogComponent {
  @Input() visible = false;
  @Input() maxLength = 500;
  @Input() selectedPatientUser: any;

  @Output() onHide = new EventEmitter<void>();
  @Output() onSaveSuccess = new EventEmitter<void>();

  @Input()
  currentUser: User;

  activityLog: any = new ActivityLogs();
  dialogLoader = false;
  private subscriptions: Subscription[] = [];

  @Input()
  reasons = [];
  optOutReason;
  dialogStyle = {
    width: '100%',
    maxWidth: '600px',
    borderRadius: '10px',
  };

  constructor(
    private patientFacadeService: PatientFacadeService,
    private toastrService: ToastrService,
    private translateSvc: TranslateService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedPatientUser'] && this.selectedPatientUser) {
      this.activityLog.patientUserId = this.selectedPatientUser.userId;
      this.activityLog.patientId = this.selectedPatientUser.patientId;
      this.activityLog.fromUserId = this.currentUser.id;
      this.activityLog.toUserId = this.selectedPatientUser.userId;
      this.activityLog.activityType = ActivityTypes.CALL;
      this.activityLog.subType = this.selectedPatientUser.counselDone
        ? CalActivitySubTypes.FollowUp
        : CalActivitySubTypes.Counsel;
    }
  }

  formIsValid(): boolean {
    // Put your validation logic here
    return (
      this.activityLog.notes &&
      this.activityLog.subType &&
      this.activityLog.isCompleted !== undefined
    );
  }

  onSubmit() {
    if (!this.formIsValid()) return;

    this.activityLog.activityTime = new Date();
    this.dialogLoader = true;
    if (
      this.activityLog.isCompleted &&
      this.activityLog.isPatientIntrested === false
    ) {
      this.activityLog.optOutReasonKey = this.optOutReason?.key;
    } else {
      this.activityLog.optOutReasonKey = '';
      this.optOutReason = null;
    }

    const sub = this.patientFacadeService
      .createActivityLog({
        ...this.activityLog,
        isPatientIntrested: !!this.activityLog.isPatientIntrested,
      })
      .subscribe(
        () => {
          this.dialogLoader = false;
          this.visible = false;

          const messageKey = !this.activityLog.isCompleted
            ? 'recordUpdated'
            : this.activityLog.subType === CalActivitySubTypes.Counsel
            ? 'counsellingSuccess'
            : 'followUpSuccess';

          const translatedMessage = this.translateSvc.instant(messageKey);
          const translatedTitle = this.translateSvc.instant('successLbl');
          this.toastrService.success(translatedMessage, translatedTitle);

          this.resetForm();
          this.onSaveSuccess.emit();
        },
        error => {
          console.error('Error creating activity log:', error);
          this.dialogLoader = false;
          this.resetForm();
        },
      );

    this.subscriptions.push(sub);
  }

  resetForm() {
    this.activityLog = {};
    this.optOutReason = null;
  }

  onDialogHide() {
    this.resetForm();
    this.onHide.emit();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
